import { sortedCopy } from '@standardnotes/utils';
export class StringToAuthenticatedDataUseCase {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(rawAuthenticatedData, override) {
        const base = JSON.parse(this.crypto.base64Decode(rawAuthenticatedData));
        return sortedCopy({
            ...base,
            ...override,
        });
    }
    executeRaw(rawAuthenticatedData) {
        const base = JSON.parse(this.crypto.base64Decode(rawAuthenticatedData));
        return base;
    }
}
